import React from "react";
import {
  Typography,
  Button,
  CardBody,
  Input,
  CardFooter,
} from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";

const CreateEdlitPlatformClient = ({
  formData,
  setFormData,
  handleBlur,
  errors,
  setErrors,
  operation,
  handleSubmission,
  isLoading,
}) => {
  const navigate = useNavigate();

  const handleCancelClick = () => {
    navigate("/ClientManagement");
  };

  const handleFileUpload = () => {};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  return (
    <>
      <CardBody className="px-3 p-0">
        <form>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Primary Contact Person
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-2 px-4">
              <div>
                <Input
                  type="text"
                  label="Primary Contact First Name"
                  size="lg"
                  value={formData.clientPrimaryContactFirstName}
                  name="clientPrimaryContactFirstName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientPrimaryContactFirstName && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientPrimaryContactFirstName}
                  </p>
                )}
              </div>
              <Input
                type="text"
                label="Primary Contact Middle Name"
                size="lg"
                value={formData.clientPrimaryContactMiddleName}
                name="clientPrimaryContactMiddleName"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
              <div>
                <Input
                  type="text"
                  label="Primary Contact Last Name"
                  size="lg"
                  value={formData.clientPrimaryContactLastName}
                  name="clientPrimaryContactLastName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientPrimaryContactLastName && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientPrimaryContactLastName}
                  </p>
                )}
              </div>
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Secondary Contact Person
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-2 px-4">
              <Input
                type="text"
                label="Secondary Contact First Name"
                size="lg"
                value={formData.clientSecondaryContactFirstName}
                name="clientSecondaryContactFirstName"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
              <Input
                type="text"
                label="Secondary Contact Middle Name"
                size="lg"
                value={formData.clientSecondContactMiddleName}
                name="clientSecondContactMiddleName"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
              <Input
                type="text"
                label="Secondary Contact Last Name"
                size="lg"
                value={formData.clientSecondContactLastName}
                name="clientSecondContactLastName"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Other Information
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-2 px-4">
              <Input
                type="text"
                label="CISO"
                size="lg"
                value={formData.clientCISO}
                name="clientCISO"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
              <div>
                <Input
                  label="Logo upload"
                  size="lg"
                  className="block w-full p-1.5 text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                  id="file_input"
                  onChange={handleFileUpload}
                  accept=".csv, .xlsx, .xls, .xlsm, .xlsb"
                  name="clientLogo"
                  type="file"
                />
                {errors.clientLogo && (
                  <p className="text-red-900 text-[12px]">
                    {errors.clientLogo}
                  </p>
                )}
              </div>
              <div>
                <Input
                  type="date"
                  label="Expiry Date"
                  size="lg"
                  value={formData.clientExpiryTimestamp}
                  name="clientExpiryTimestamp"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientExpiryTimestamp && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientExpiryTimestamp}
                  </p>
                )}
              </div>
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Client Details
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 px-4">
              <div>
                <Input
                  type="text"
                  label="Legal Name"
                  size="lg"
                  value={formData.clientLegalName}
                  name="clientLegalName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientLegalName && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientLegalName}
                  </p>
                )}
              </div>
              <div>
                <Input
                  type="text"
                  label="Short Name"
                  size="lg"
                  value={formData.clientShortName}
                  name="clientShortName"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientShortName && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientShortName}
                  </p>
                )}
              </div>
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Email
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 px-4">
              <div>
                <Input
                  type="email"
                  label="Primary Email"
                  size="lg"
                  value={formData.clientPrimaryContactEmail}
                  name="clientPrimaryContactEmail"
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientPrimaryContactEmail && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientPrimaryContactEmail}
                  </p>
                )}
              </div>
              <Input
                type="email"
                label="Secondary Email"
                size="lg"
                value={formData.clientSecondaryContactEmail}
                name="clientSecondaryContactEmail"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <></>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Mobile Number
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 px-4">
              <div>
                <Input
                  type="tel"
                  label="Primary Contact Mobile Number"
                  size="lg"
                  value={formData.clientPrimaryContactMobileNumber}
                  name="clientPrimaryContactMobileNumber"
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientPrimaryContactMobileNumber && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientPrimaryContactMobileNumber}
                  </p>
                )}
              </div>
              <Input
                type="tel"
                label="Secondary Contact Mobile Number"
                size="lg"
                value={formData.clientSecondaryContactMobileNumber}
                name="clientSecondaryContactMobileNumber"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Phone Number
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 px-4">
              <div>
                <Input
                  type="tel"
                  label="Primary Contact Phone Number"
                  size="lg"
                  value={formData.clientPrimaryContactPhoneNumber}
                  name="clientPrimaryContactPhoneNumber"
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientPrimaryContactPhoneNumber && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientPrimaryContactPhoneNumber}
                  </p>
                )}
              </div>
              <Input
                type="tel"
                label="Secondary Contact Phone Number"
                size="lg"
                value={formData.clientSecondaryContactPhoneNumber}
                name="clientSecondaryContactPhoneNumber"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Address
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 px-4">
              <div>
                <Input
                  type="text"
                  label="Registered Address"
                  size="lg"
                  value={formData.clientRegisteredAddress}
                  name="clientRegisteredAddress"
                  onChange={handleChange}
                  className="focus:!border-2 focus:!border-t-0 focus:!border-black"
                />
                {errors.clientRegisteredAddress && (
                  <p className="text-red-900 text-[12px] mt-[0.5px]">
                    *{errors.clientRegisteredAddress}
                  </p>
                )}
              </div>
              <Input
                type="text"
                label="Correspondence Address"
                size="lg"
                value={formData.clientCorrespondenceAddress}
                name="clientCorrespondenceAddress"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <>
            <Typography
              variant="h6"
              color="blue-gray"
              className="px-4 font-semibold"
            >
              Domains
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 py-2 px-4 mb-3">
              <Input
                type="text"
                label="Domain"
                size="lg"
                value={formData.clientDomain}
                name="clientDomain"
                onChange={handleChange}
                className="focus:!border-2 focus:!border-t-0 focus:!border-black"
              />
            </div>
          </>
          <div className="flex justify-end p-3">
            <span className="text-red-900 font-bold text-lg">*</span>
            <span className="text-red-900 font-semibold">Mandatory fields</span>
          </div>
        </form>
      </CardBody>
      <CardFooter className="flex items-center justify-end gap-4 p-4">
        <Button
          variant="text"
          size="lg"
          color="red"
          onClick={handleCancelClick}
        >
          Cancel
        </Button>
        <Button
          variant="gradient"
          size="lg"
          color="green"
          type="submit"
          onClick={handleSubmission}
          loading={isLoading === null ? true : false}
        >
          {operation === "create" ? "Submit" : "Update"}
        </Button>
      </CardFooter>
    </>
  );
};

export default CreateEdlitPlatformClient;
